export class Locker {
    private waitList: (() => void)[] = []

    private locking = false

    async lock<T>(fn: () => T): Promise<T> {
        if (this.locking) {
            await new Promise<void>(resolve => this.waitList.push(resolve))
        }
        try {
            return await fn();
        } finally {
            const next = this.waitList.shift();
            if (next) {
                setTimeout(next)
            }
        }
    }
}